import { client } from '@studio/api/api-client/client';
import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import * as SessionStore from '@studio/storeV2/authentication/session-store';
import * as Store from '@studio/storeV2/store';
import type { ApiClientConfig } from '@studio/types/axios';

const _LOGOUT_URL = `${CENTRAL_API_V3}/logout`;

type _LogoutCallbacks = { onError?: () => void; onFinally?: () => void; onSuccess?: () => void };

/**
 * Logout core. POSTs to `/logout`, then always clears local session state and resets
 * stores. Callable from React (`useSignOut`) and module scope (401 interceptor, fetchMe failure).
 * `session.clear()` leaves `tokenExpired` intact for the login screen.
 */
export default async function performLogout({ onError, onFinally, onSuccess }: _LogoutCallbacks = {}): Promise<void> {
  const config: ApiClientConfig = {
    method: HTTP_METHODS.POST,
    token: SessionStore.session.getAccessToken(),
    withCredentials: true,
  };
  try {
    await client(_LOGOUT_URL, config);
  } catch (err) {
    console.error(err);
    onError?.();
  } finally {
    SessionStore.session.clear();
    onSuccess?.();
    Store.reset();
    onFinally?.();
  }
}
